import { capitalize } from "lodash";

export const convertKeyToRoleName = (key: string) => {
  const keyArr = key.split("_");
  return keyArr.map((item) => capitalize(item)).join(" ");
};
